export enum ESpecialty {
  GASTROENTEROLOGY = "GASTROENTEROLOGY",
  HEPATOLOGY = "HEPATOLOGY",
  NUTRITION = "NUTRITION",
  DIETETICS = "DIETETICS",
  OTHER = "OTHER",
}

export enum ETypeIdentification {
  DNI = "DNI",
  NIE = "NIE",
  PASSPORT = "PASSPORT",
}

export enum EProviderRole {
  INDIVIDUAL = "INDIVIDUAL",
  INSTITUTION_ADMIN = "INSTITUTION_ADMIN",
  EMPLOYEE = "EMPLOYEE",
}

export enum EConnectionInitiator {
  PROVIDER = "PROVIDER",
  PATIENT = "PATIENT",
}

export enum EConnectionStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  NULL = "NULL",
}

export enum EGender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
  PREFER_NOT_TO_SAY = "PREFER_NOT_TO_SAY",
}

export enum EDigestiveConditions {
  IBS = "IRRITABLE_BOWEL_SYNDROME",
  IBD = "INFLAMMATORY_BOWEL_DISEASE",
  REFLUX = "GASTROESOPHAGEAL_REFLUX_DISEASE",
  SIBO = "SIBO",
  DYSPEPSIA = "DYSPEPSIA",
  LACTOSE_INTOLERANCE = "LACTOSE_INTOLERANCE",
  CELIAC_DISEASE = "CELIAC_DISEASE",
  GASTRITIS = "GASTRITIS",
  PEPTIC_ULCER = "PEPTIC_ULCER",
  FRUCTOSE_INTOLERANCE = "FRUCTOSE_INTOLERANCE",
  NULL = "NULL",
}

export enum EMealType {
  BREAKFAST = "BREAKFAST",
  LUNCH = "LUNCH",
  AFTERNOON_SNACK = "AFTERNOON_SNACK",
  DINNER = "DINNER",
  SNACK = "SNACK",
}

export enum EStoolType {
  TYPE_1 = "TYPE_1",
  TYPE_2 = "TYPE_2",
  TYPE_3 = "TYPE_3",
  TYPE_4 = "TYPE_4",
  TYPE_5 = "TYPE_5",
  TYPE_6 = "TYPE_6",
  TYPE_7 = "TYPE_7",
}

export enum EStoolColor {
  BROWN = "BROWN",
  GREEN = "GREEN",
  RED = "RED",
  YELLOW = "YELLOW",
  BLACK = "BLACK",
}

export enum ESymptom {
  HEARTBURN = "HEARTBURN",
  ABDOMINAL_PAIN = "ABDOMINAL_PAIN",
  CHEST_PAIN = "CHEST_PAIN",
  DYSPHAGIA = "DYSPHAGIA",
  FATIGUE = "FATIGUE",
  FEVER = "FEVER",
  FLATULENCE = "FLATULENCE",
  BLOATING = "BLOATING",
  INCONTINENCE = "INCONTINENCE",
  NAUSEA_AND_VOMITING = "NAUSEA_AND_VOMITING",
  RECTAL_BLEEDING = "RECTAL_BLEEDING",
  FEELING_OF_FULLNESS = "FEELING_OF_FULLNESS",
  EARLY_SATIETY = "EARLY_SATIETY",
  SWEATING = "SWEATING",
  TENESMUS = "TENESMUS",
  FECAL_URGENCY = "FECAL_URGENCY",
  PAIN_DURING_DEFECATION = "PAIN_DURING_DEFECATION",
  FEELING_OF_INCOMPLETE_EVACUATION = "FEELING_OF_INCOMPLETE_EVACUATION",
  GENERAL_DISCOMFORT = "GENERAL_DISCOMFORT",
  EXCESSIVE_STRAINING_DURING_DEFECATION = "EXCESSIVE_STRAINING_DURING_DEFECATION",
}

export enum ERegisterType {
  MEALS = "MEALS",
  SYMPTOMS = "SYMPTOMS",
  STOOLS = "STOOLS",
  WEIGHT = "WEIGHT",
}

export enum EDeleteAccountReason {
  NO_USAGE = "NO_USAGE",
  SUBSCRIPTION = "SUBSCRIPTION",
  ALTERNATIVE = "ALTERNATIVE",
  BAD_UX = "BAD_UX",
  PATIENTS = "PATIENTS",
  NOT_USEFUL = "NOT_USEFUL",
}
